import React, { useContext } from 'react'
import './IconCart.css'
import { CartContext } from '../../context/CartContext';
// const cart = require('../../assets/cart.png')
const cart2 = require('../../assets/cart2.png')
export default function IconCart() {
  const { cart } = useContext(CartContext);

  // Tính tổng số lượng sản phẩm trong giỏ hàng
  const totalItems = cart.reduce((total, item) => total + item.quantity, 0);
  return (
    <div class="cart-container right">
    {/* <NavLink id="cart-btn" href="/Cart" target="_blank" rel="noopener nofollow"> */}
    <a id="cart-btn" href="/Cart" rel="noopener nofollow">
        <div class="animated_cart infinite zoomIn_cart cmo-cart-circle"></div>
        <div class="animated_cart infinite pulse_cart cmo-cart-circle-fill"></div>
        {totalItems > 0 && (
          <div className='counter-container'>
            <p>{totalItems > 99 ? "99+" : totalItems}</p>
          </div>
        )}
        <span><img src={cart2} alt="My Cart"/></span>
    </a>
    </div>
  )
}
